(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("angular-barcode-scanner", [], factory);
	else if(typeof exports === 'object')
		exports["angular-barcode-scanner"] = factory();
	else
		root["angular-barcode-scanner"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition